import {currencyValueDivider} from '@shared/constants';
import {createTranslationDict} from '@shared/helpers';
import {getLocalizedText} from '@shared/utils';
import {VoucherConfig, VoucherConfigDetails} from '../types';
import {
  VoucherConfigDetailsOnBackend,
  VoucherConfigOnBackend,
} from './backendTypes';

export const mapVoucherConfigFromBackend = ({
  id,
  title,
  currencies,
  voucher_ttl_days,
}: VoucherConfigOnBackend): VoucherConfig => ({
  id,
  title,
  amounts: currencies
    .map(({currency, amount}) => ({
      currency,
      amount: amount / currencyValueDivider,
    }))
    .sort((a, b) => Number(b.currency === 'USD') - Number(a.currency === 'USD')),
  ttlDays: voucher_ttl_days,
});

export const mapVoucherConfigDetailsFromBackend = ({
  name,
  ...reward
}: VoucherConfigDetailsOnBackend): VoucherConfigDetails => ({
  ...mapVoucherConfigFromBackend({...reward, title: getLocalizedText(name)}),
  nameTranslations: createTranslationDict(name),
});
